import { apiInstance } from './api';
import { ApiRoutes } from './consts';

export const getCampaignsInformation = async (params?: { startDate?: string; endDate?: string }) => {
  return apiInstance.get(`${ApiRoutes.Analytics}/campaigns`, {
    params: {
      startDate: params?.startDate,
      endDate: params?.endDate,
    },
  });
};

export const getCampaignsByTimeline = async (params?: { 
  filter?: string;
  startDate?: string;
  endDate?: string;
}) => {
  return apiInstance.get(`${ApiRoutes.Analytics}/timeline`, {
    params: { 
      filter: params?.filter ?? 'monthly',
      startDate: params?.startDate,
      endDate: params?.endDate,
    },
  });
};

export const getEmailMetrics = async ({ startDate, endDate }: { startDate: string; endDate: string }) => {
  return apiInstance.get(`${ApiRoutes.Analytics}/email-metrics`, {
    params: { startDate, endDate },
  });
};

export const getSmsMetrics = async ({ startDate, endDate }: { startDate: string; endDate: string }) => {
  return apiInstance.get(`${ApiRoutes.Analytics}/sms-metrics`, {
    params: { startDate, endDate },
  });
};

export const getRatingsAnalytics = async (params?: {
  startDate?: string;
  endDate?: string;
  connection?: string;
  period?: 'daily' | 'weekly' | 'monthly';
}) => {
  const googleAccessToken = localStorage.getItem('googleAccessToken');
  
  return apiInstance.get(`${ApiRoutes.Analytics}/business-reviews`, {
    headers: googleAccessToken ? {
      'google-access-token': googleAccessToken,
    } : undefined,
    params: {
      startDate: params?.startDate,
      endDate: params?.endDate,
      connection: params?.connection ?? 'all',
      period: params?.period ?? 'monthly',
    },
  });
};

export const getReviewMetrics = async () => {
  const googleAccessToken = localStorage.getItem('googleAccessToken');
  const businessId = localStorage.getItem('businessId');
  
  return apiInstance.get(`${ApiRoutes.Analytics}/review-metrics`, {
    headers: {
      'echo-business-id': businessId || '',
      ...(googleAccessToken && { 'google-access-token': googleAccessToken }),
    },
  });
};

export const getDashboardMetrics = async () => {
  const businessId = localStorage.getItem('businessId');

  return apiInstance.get(`${ApiRoutes.Analytics}/dashboard-metrics`, {
    headers: {
      'echo-business-id': businessId || '',
    },
  });
};
